import React from 'react';
import { MASS_ACTION } from 'constants/config';
import { Icon, Spinner } from 'ui';

const ActionBarStatus = ({
  loading,
  hasError,
  bulkDone,
  selectedItems,
  bulkName,
  bulkCount,
  bulkInProgress,
  updatedShared,
}) => {
  const translationOptions = resource => ({
    count: updatedShared.length,
    [resource]: updatedShared.length > 0 ? updatedShared[0].name : '',
    bulkCount,
  });

  const doneMessage = () => {
    let options;

    switch (bulkName) {
      case MASS_ACTION.RESTORE:
        return t('mass_actions.restore.success', { count: bulkCount });
      case MASS_ACTION.ARCHIVE:
        return t('mass_actions.archive.success', { count: bulkCount });
      case MASS_ACTION.MASS_LEARN:
        options = translationOptions('group');
        return bulkCount > 1
          ? t('mass_actions.mass_learn.updated.items', options)
          : t('mass_actions.mass_learn.updated.item', options);
      case MASS_ACTION.MASS_OWNERSHIP:
        options = translationOptions('owner');
        return bulkCount > 1
          ? t('mass_actions.mass_ownership.updated.items', options)
          : t('mass_actions.mass_ownership.updated.item', options);
      case MASS_ACTION.MASS_TAGGING:
        options = translationOptions('tag');
        return bulkCount > 1
          ? t('mass_actions.mass_tagging.updated.items', options)
          : t('mass_actions.mass_tagging.updated.item', options);
      default:
        return '';
    }
  };

  const renderBulkDone = () => (
    <div className="Index-success">
      <Icon name="completed" className="Index-toolbarStateIcon" />
      {doneMessage()}
    </div>
  );

  const renderFail = () => (
    <div className="Index-fail">
      <Icon name="info" className="Index-toolbarStateIcon" />
      <span>{t('mass_actions.failed')}</span>
    </div>
  );

  const loadingMessage = () => {
    switch (bulkName) {
      case MASS_ACTION.RESTORE:
        return t('mass_actions.restore.restoring', { count: bulkCount });
      case MASS_ACTION.ARCHIVE:
        return t('mass_actions.archive.archiving', { count: bulkCount });
      case MASS_ACTION.MASS_LEARN:
      case MASS_ACTION.MASS_OWNERSHIP:
        return t('mass_actions.applying', { count: bulkCount });
      default:
        return '';
    }
  };

  const renderLoading = () => {
    const label = bulkInProgress ? loadingMessage() : t('mass_actions.looking');

    return (
      <div className="Index-loading">
        <Spinner />
        <span style={{ marginLeft: '8px' }}>{label}</span>
      </div>
    );
  };

  const render = () => {
    if (hasError) return renderFail();
    if (loading && !bulkDone) return renderLoading();
    if (bulkDone) return renderBulkDone();
    return t('mass_actions.looking');
  };

  return <div>{render()}</div>;
};

export default ActionBarStatus;
